import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const MensageriaLogList = props => <DefaultDataTable data={props} />;
